import React from "react";
// component
import Checkout from "./Checkout";

export default function FormikCheckout() {
  return (
    <div>
      <Checkout />
    </div>
  );
}
